// extracted by mini-css-extract-plugin
module.exports = {"header1":"GlobalConsumption_header1__1kCiR","header2":"GlobalConsumption_header2__hsYPk","periodSelector":"GlobalConsumption_periodSelector__33voO"};